export default () => ({
  brokenLinks: []
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/repair-links/state.js